import { render, staticRenderFns } from "./CardPersonalData.vue?vue&type=template&id=6fc7981f&scoped=true"
import script from "./CardPersonalData.vue?vue&type=script&lang=js"
export * from "./CardPersonalData.vue?vue&type=script&lang=js"
import style0 from "./CardPersonalData.vue?vue&type=style&index=0&id=6fc7981f&scoped=true&lang=css"
import style1 from "./CardPersonalData.vue?vue&type=style&index=1&id=6fc7981f&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc7981f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fc7981f')) {
      api.createRecord('6fc7981f', component.options)
    } else {
      api.reload('6fc7981f', component.options)
    }
    module.hot.accept("./CardPersonalData.vue?vue&type=template&id=6fc7981f&scoped=true", function () {
      api.rerender('6fc7981f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OnboardingDetailPerson/components/CardPersonalData.vue"
export default component.exports